import { isValueEmpty } from '@awp/helpers/utilsReact';
import { CrudService, EntityProps } from '@awp/shared/CrudService';
import React from 'react';
import { ENTITY_TITLES } from '@awp/constants';

export default class GraphPresetService extends CrudService {
  constructor(mode: string) {
    const entityName = ENTITY_TITLES.GRAPH_PRESET;
    const entityPluralName = ENTITY_TITLES.GRAPH_PRESETS;
    super({ entityName, entityPluralName, mode });
  }

  getActionMenu(event: any): React.ReactElement {
    return <></>;
  }

  getColumns(props: any): any {
    /* Do Nothing */
  }

  getFields(props: any): React.ReactElement {
    return <></>;
  }

  getValidations(props?: any): any {
    /* Do Nothing */
  }

  mapFormToDTO(props: EntityProps): any {
    /* Do Nothing */
  }

  mapInitialValues(props: EntityProps): any {
    const { entity, ...rest } = props;
    return {
      ...entity,
      DataGraphs: entity.DataGraphs?.map((graph: any) => ({
        ...graph,
        PersistentGraphFilters: graph.PersistentGraphFilters?.map((filter: any) => {
          return {
            ...filter,
            ColorCodeOverride: isValueEmpty(filter.ColorCodeOverride) ? null : filter.ColorCodeOverride,
            Concurrency: undefined,
            GraphFilterId: undefined,
            DatasetPrefix: undefined,
          };
        }),
      })),
    };
  }

  cleanFormValues(props: EntityProps): any {
    /* Do Nothing */
  }
}
